/* eslint-disable */
import { Add, Archive, ChevronLeft, Delete, MoreVert, Refresh } from '@material-ui/icons';
import FilterableTable from '../../components/FilterableTable/FilterableTable';
import { CircularProgress, Grid, Icon, IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import moment from 'moment-timezone';
import { convertConstantLiteralToNormal, formatDate, getUserDisplayName } from '../../utils/string.helpers';
import { InventoryCountOrder, ItemHandlingUnit, RootState } from '../../store/config/types';
import { useEffect, useRef, useState } from 'react';
import { ThunkDispatch } from 'redux-thunk';
import { setToast } from '../../store/actions/toast.actions';
import { connect, ConnectedProps } from 'react-redux';
import WarehouseWorkService, { InventoryCountService } from '../../services/warehouseWork.service';
import Card from '../../components/Card/Card';
import CardHeader from '../../components/Card/CardHeader';
import CardBody from '../../components/Card/CardBody';
import { useHistory } from 'react-router-dom';
import { fetchWarehouses } from '../../store/actions/warehouses.actions';
import AddButton from '../../components/CustomButtons/AddButton';
import ConfirmationDialog, { ConfirmationDialogProps } from '../../components/ConfirmationDialog/ConfirmationDialog';
import InventoryCountOrderDetails from './InventoryCountOrderDetails';
import { InventoryCountOrderStatus, InventoryCountOrderStatusOrder } from '../../store/config/enums/warehouseWork.enum';
import StatusChip from '../../components/StatusChip/StatusChip';
import { HandlingUnitListDialog } from '../../components/HandlingUnitListDialog/HandlingUnitListDialog';
import CommentPreview from '../../components/Comments/CommentPreview';
import { CommentThread } from '../../store/config/types/comment.types';
import CommentsDialog from '../../components/CommentsDialog/CommentsDialog';
import InventoryCountSyncConfirmationDialog from '../../components/InventoryCountSyncConfirmationDialog/InventoryCountSyncConfirmationDialog';

const REFRESH_MILISECONDS = 30000;

const mapStateToProps = (state: RootState) => {
  return {
    auth: state.auth,
    loggedIn: state.auth.loggedIn,
    warehouses: state.warehouses?.warehouses,
  };
};
const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, any>) => ({
  setToast: (message: string, messageType: string) => dispatch(setToast(message, messageType)),
  fetchWarehouses: (shipperId: number) => dispatch(fetchWarehouses(shipperId)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
// interface InventoryCountOrders {
//   ORDERS: InventoryCountOrder[];
//   PENDING: InventoryCountOrder[];
// }

interface ICTab {
  caption: string;
  id: number;
}
function InventoryCountManagement({ auth, warehouses, fetchWarehouses, setToast }: PropsFromRedux) {
  const [inventoryCountOrders, setInventoryCountOrders] = useState<InventoryCountOrder[]>([]);
  const [currentTab, setCurrentTab] = useState<number>(0);
  const [orderTabs, setOrderTAbs] = useState<ICTab[]>([]);
  const [loading, setLoading] = useState(false);
  const [needsRefresh, setNeedsRefresh] = useState<boolean>(false);
  const [date, setDate] = useState<string>(moment().format('YYYY-MM-DD'));
  const history = useHistory();
  const [lastRefresh, setLastRefresh] = useState<Date>(new Date());
  const commentsCallBackRef = useRef<any>();
  const [confirmationDialogProps, setConfirmationDialogProps] = useState<ConfirmationDialogProps>({
    open: false,
    message: 'Are you sure?',
    onConfirm: () => {},
    onCancel: () => {},
    okBtnCaption: 'Yes',
    cancelBtnCaption: 'No',
    processing: false,
  });
  const [handlingUnitsToShow, setHandlingUnitsToShow] = useState<ItemHandlingUnit[]>();
  const [activeCommentThread, setActiveCommentThread] = useState<CommentThread>();
  const [syncConfirmation, setSyncConfirmation] = useState<{
    open: boolean;
    order?: InventoryCountOrder;
    ids: number[];
    processing: boolean;
  }>({ open: false, ids: [], processing: false });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [currentIC, setCurrentIC] = useState<InventoryCountOrder | null>(null);

  function refetchData() {
    console.log(auth);
    if (auth?.account?.shipper?.timezone) moment.tz.setDefault(auth?.account?.shipper?.timezone);
    setNeedsRefresh(false);
    if (!loading) {
      setLoading(true);
      InventoryCountService.fetchInventoryCountOrders(date)
        .then((response) => {
          setInventoryCountOrders(
            response.sort((ic1, ic2) => {
              const order =
                InventoryCountOrderStatusOrder[ic1.status ?? InventoryCountOrderStatus.SYNCED] -
                InventoryCountOrderStatusOrder[ic2.status ?? InventoryCountOrderStatus.SYNCED];
              return order != 0 ? order : moment(ic1.date).unix() - moment(ic2.date).unix();
            }),
          );
          setNeedsRefresh(false);
        })
        .finally(() => {
          setLoading(false);
          setLastRefresh(new Date());
        });
    }
  }
  const confirmDialog = (message: string, okBtnCaption = 'Yes', cancelBtnCaption = 'No'): Promise<boolean> => {
    return new Promise((resolve) => {
      setConfirmationDialogProps({
        open: true,
        message,
        okBtnCaption,
        cancelBtnCaption,
        processing: false,
        onConfirm: () => {
          setConfirmationDialogProps((prev) => ({ ...prev, open: false }));
          resolve(true);
        },
        onCancel: () => {
          setConfirmationDialogProps((prev) => ({ ...prev, open: false }));
          resolve(false);
        },
      });
    });
  };

  function handleOperation(operation: string, data: any[], targetObject?: any): void {
    console.log({ operation, data, targetObject });
    setAnchorEl(null);
    setCurrentIC(null);
    const ids = data.map((d) => d.inventoryCountOrderId);
    switch (operation) {
      case 'inventory-count-approve-row':
        confirmDialog('Are you sure you want to approve this inventory count row?').then((res) => {
          if (res) {
            WarehouseWorkService.approveInventoryCountRow(data)
              .then(() => {
                refetchData();
                setToast('Inventory count row approved successfully', 'success');
              })
              .catch((err) => {
                setToast(err.message, 'danger');
              });
          }
        });
        break;
      case 'inventory-count-reject-row':
        confirmDialog('Are you sure you want to reject this inventory count row?').then((res) => {
          if (res) {
            WarehouseWorkService.rejectInventoryCountRow(data)
              .then(() => {
                refetchData();
                setToast('Inventory count row rejected successfully', 'success');
              })
              .catch((err) => {
                setToast(err.message, 'danger');
              });
          }
        });
        break;
      case 'inventory-count-clear-row':
        confirmDialog('Are you sure you want to clear this inventory count row?').then((res) => {
          if (res) {
            WarehouseWorkService.clearInventoryCountRow(data)
              .then(() => {
                refetchData();
                setToast('Inventory count row cleared successfully', 'success');
              })
              .catch((err) => {
                setToast(err.message, 'danger');
              });
          }
        });
        break;
      case 'inventory-count-order-approve':
        confirmDialog('Are you sure you want to approve this inventory count order?').then((res) => {
          if (res) {
            setLoading(true);
            WarehouseWorkService.approveInventoryCountOrder(ids)
              .then(() => {
                refetchData();
                setToast('Inventory count order approved successfully', 'success');
              })
              .catch((err) => {
                setToast(err.message, 'danger');
              })
              .finally(() => {
                setLoading(false);
              });
          }
        });
        break;
      // case 'inventory-count-order-approve-sync':
      //   confirmDialog(
      //     `These counts will overwrite existing values in NetSuite. You can still review and edit them during approval. Press Sync to continue.\n\nNote: Inventory adjustments are applied only after the Inventory Count is completed and approved in NetSuite.`,
      //   ).then((res) => {
      //     if (res) {
      //       setLoading(true);
      //       WarehouseWorkService.approveInventoryCountOrderSync(ids)
      //         .then(() => {
      //           refetchData();
      //           setToast('Inventory count order approved successfully', 'success');
      //         })
      //         .catch((err) => {
      //           setToast(err.message, 'danger');
      //         })
      //         .finally(() => {
      //           setLoading(false);
      //         });
      //     }
      //   });
      //   break;
      case 'inventory-count-order-reject':
        confirmDialog('Are you sure you want to reject this inventory count order?').then((res) => {
          if (res) {
            WarehouseWorkService.rejectInventoryCountOrder(ids)
              .then(() => {
                refetchData();
                setToast('Inventory count order rejected successfully', 'success');
              })
              .catch((err) => {
                setToast(err.message, 'danger');
              });
          }
        });
        break;
      case 'inventory-count-order-cancel':
        if (currentTab === 0 && !ids.length) {
          setToast('Please select an inventory count order', 'danger');
          return;
        }
        confirmDialog('Are you sure you want to cancel this inventory count order?').then((res) => {
          if (res) {
            setLoading(true);
            WarehouseWorkService.cancelInventoryCountOrder(ids)
              .then(() => {
                refetchData();
                setToast('Inventory count order cancelled successfully', 'success');
                if (currentTab > 0) handleBackButtonClick();
              })
              .catch((err) => {
                setToast(err.message, 'danger');
              })
              .finally(() => {
                setLoading(false);
              });
          }
        });
        break;
      case 'inventory-count-order-refresh-snapshot':
        setLoading(true);
        WarehouseWorkService.refreshSnapshotInventoryCountOrder(ids)
          .then(() => {
            refetchData();
            setToast('Inventory snapshot refreshed successfully', 'success');
          })
          .catch((err) => {
            setToast(err.message, 'danger');
          })
          .finally(() => {
            setLoading(false);
          });
        break;
      case 'inventory-count-order-try-sync':
        setSyncConfirmation({
          open: true,
          order: data[0] as InventoryCountOrder,
          ids,
          processing: false,
        });
        break;

      case 'display-handling-units':
        setHandlingUnitsToShow(data);
        break;
      case 'close-order-tabs':
        setOrderTAbs((orders) => [...orders.filter((o) => !data.includes(o.id))]);
        setCurrentTab(0);
        break;
      case 'open-comments-dialog':
        setActiveCommentThread(targetObject.thread);
        commentsCallBackRef.current = targetObject.callback;
        break;
      default:
        console.log(operation, data);
    }
  }

  const handleCreateInventoryCountOrder = () => {
    history.push('/inventory-management/inventory-count/new');
  };

  const handleCancelInventoryCountOrder = () => {
    handleOperation('inventory-count-order-cancel', [getCurrentOrder()]);
  };

  function handleClickOnItem(row: any) {
    const ic: InventoryCountOrder = row.inventoryCountOrder;
    const tabIndex = orderTabs.findIndex((t) => t.id == ic.inventoryCountOrderId);
    if (tabIndex < 0) {
      setOrderTAbs((allTabs) => [
        ...orderTabs,
        { caption: `IC #${ic.inventoryCountOrderId}`, id: ic.inventoryCountOrderId ?? 0 },
      ]);
      setCurrentTab(ic.inventoryCountOrderId ?? 0);
    } else {
      setCurrentTab(orderTabs[tabIndex].id);
    }
  }

  function handleCommentsDialogClose() {
    setActiveCommentThread(undefined);
  }
  function handleCommentThreadUpdate(updatedThread: CommentThread): void {
    if (commentsCallBackRef.current) commentsCallBackRef.current(updatedThread);
  }

  const getCurrentOrder = () => {
    return inventoryCountOrders.find((ic) => ic.inventoryCountOrderId === currentTab);
  };

  useEffect(() => {
    if (date) setNeedsRefresh(true);
  }, [date]);

  useEffect(() => {
    if (!warehouses?.length && auth?.account?.shipper?.shipperId) {
      fetchWarehouses(auth?.account?.shipper?.shipperId);
    }
  }, [fetchWarehouses, warehouses, auth]);

  useEffect(() => {
    if (needsRefresh) {
      refetchData();
    }
  }, [needsRefresh]);

  // Auto-refresh data every REFRESH_MILISECONDS
  useEffect(() => {
    const intervalId = setInterval(() => {
      setNeedsRefresh(true);
    }, REFRESH_MILISECONDS);

    return () => clearInterval(intervalId);
  }, [date]);

  function handleBackButtonClick(): void {
    if (currentTab > 0) {
      setCurrentTab(0);
    } else {
      history.goBack();
    }
  }

  function handleICMenuClick(e: any, ic: InventoryCountOrder): void {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setCurrentIC(ic);
  }

  function handleicMenuClose(): void {
    setAnchorEl(null);
    setCurrentIC(null);
  }
  function getPageTitle() {
    if (currentTab === 0) return <span>Inventory Count</span>;
    const currentOrder = getCurrentOrder();
    if (currentOrder?.additionalData?.label) {
      return (
        <span style={{ marginRight: 16 }}>
          <a
            href={currentOrder.additionalData.externalLink}
            target="_blank"
            rel="noreferrer"
            style={{ color: 'white' }}
          >
            {currentOrder.additionalData.label}
          </a>
        </span>
      );
    }
    return <span>{`Inventory Count #${currentOrder?.inventoryCountOrderId}`}</span>;
  }

  return (
    <Card>
      <CardHeader color="primary">
        <Grid container p={0} m={0} alignItems="center">
          <Grid item flexGrow={1}>
            <Grid container gap={1} alignItems={'center'}>
              <IconButton size="small" onClick={handleBackButtonClick}>
                <ChevronLeft style={{ color: 'white' }} />
              </IconButton>
              <Grid item>{getPageTitle()}</Grid>
              {currentTab > 0 && (
                <Grid>
                  <CommentPreview
                    badgeOnly
                    entityInfo={{ entity: 'inventoryCount', entityId: getCurrentOrder()?.inventoryCountOrderId ?? 0 }}
                    theme="dark"
                    onClick={(thread, callback) => handleOperation('open-comments-dialog', [], { thread, callback })}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item alignItems="center" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <IconButton
              size="small"
              onClick={() => {
                if (!loading) setNeedsRefresh(true);
              }}
            >
              {loading ? (
                <CircularProgress size={24} style={{ color: 'white' }} />
              ) : (
                <Refresh style={{ color: 'white' }} />
              )}
            </IconButton>
            {loading ? (
              <CircularProgress size={24} style={{ color: 'white' }} />
            ) : currentTab === 0 ? (
              <IconButton size="small" onClick={handleCreateInventoryCountOrder}>
                <Add style={{ color: 'white' }} />
              </IconButton>
            ) : (
              <IconButton size="small" onClick={handleCancelInventoryCountOrder}>
                <Delete style={{ color: 'white' }} />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </CardHeader>
      <CardBody>
        <Grid container>
          {currentTab > 0 ? (
            <InventoryCountOrderDetails
              inventoryCountOrder={getCurrentOrder()}
              onAction={handleOperation}
              disableActions={loading}
              lastRefresh={lastRefresh}
            />
          ) : (
            <FilterableTable
              onClickItem={(row) => handleClickOnItem(row)}
              columns={[
                {
                  field: 'id',
                  caption: 'ID',
                  filterType: 'string',
                  sortable: true,
                  render(row) {
                    let label: any = row.id;
                    if (row.inventoryCountOrder.additionalData?.label) {
                      label = (
                        <a href={row.inventoryCountOrder.additionalData.externalLink} target="_blank" rel="noreferrer">
                          {row.inventoryCountOrder.additionalData.label}
                        </a>
                      );
                    }
                    return (
                      <Grid container gap={1} alignItems={'center'} flexWrap={'nowrap'}>
                        <IconButton
                          size="small"
                          onClick={(e) => handleICMenuClick(e, row.inventoryCountOrder)}
                          disabled={['SYNCED'].includes(row.inventoryCountOrder.status)}
                        >
                          <MoreVert />
                        </IconButton>
                        {label}
                      </Grid>
                    );
                  },
                },
                {
                  field: 'date',
                  caption: 'Date',
                  filterType: 'date',
                  sortable: true,
                  render: (row) => formatDate(row.date),
                },
                {
                  field: 'warehouseName',
                  caption: 'Warehouse',
                  filterType: 'values',
                },
                {
                  field: 'humanizedStatus',
                  caption: 'Status',
                  filterType: 'values',
                  sortable: true,
                  render(row) {
                    return <StatusChip status={row.status} />;
                  },
                },
                {
                  field: 'warehouseUserDisplayName',
                  caption: 'Assigned To',
                  filterType: 'values',
                },
                {
                  field: 'approvedBy',
                  caption: 'Approved by',
                  filterType: 'values',
                },
                {
                  field: 'comments',
                  caption: 'Comments',
                  render(row) {
                    return (
                      <CommentPreview
                        style={{ maxWidth: 200 }}
                        entityInfo={{ entity: 'inventoryCount', entityId: row.inventoryCountOrderId }}
                        onClick={(thread, callback) =>
                          handleOperation('open-comments-dialog', [], { thread, callback })
                        }
                      />
                    );
                  },
                },
              ]}
              defaultSortBy=""
              primaryKey="inventoryCountOrderId"
              data={
                inventoryCountOrders.map((cc) => {
                  moment.tz.setDefault(auth?.account?.timezone);
                  const approveHisrory = cc.orderInfo?.actionHistory?.find(
                    (ah) => ah.status == InventoryCountOrderStatus.APPROVED,
                  );

                  return {
                    inventoryCountOrderId: cc.inventoryCountOrderId,
                    id: cc.additionalData?.label ?? `#${cc.inventoryCountOrderId}`,
                    date: cc.date,
                    warehouse: cc.warehouse,
                    warehouseName: cc.warehouse?.name,
                    status: cc.status,
                    humanizedStatus: convertConstantLiteralToNormal(cc.status),
                    warehouseUser: cc.warehouseUser,
                    warehouseUserDisplayName: getUserDisplayName(cc.warehouseUser),
                    approvedBy: approveHisrory?.userInfo?.displayName,
                    inventoryCountOrder: cc,
                  };
                }) ?? []
              }
              onCumulativeOperation={handleOperation}
            />
          )}
        </Grid>
        {currentTab === 0 && <AddButton onClick={handleCreateInventoryCountOrder} />}
        <ConfirmationDialog {...confirmationDialogProps} />
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleicMenuClose}>
          {currentIC?.status &&
            (!['SYNCED'].includes(currentIC.status) ? (
              <>
                <MenuItem onClick={() => handleOperation('inventory-count-order-cancel', [currentIC])}>
                  <ListItemIcon sx={{ color: 'error.main' }}>
                    <Delete />
                  </ListItemIcon>
                  Cancel
                </MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={() => handleOperation('inventory-count-order-archive', [currentIC])}>
                  <ListItemIcon sx={{ color: 'success.main' }}>
                    <Archive />
                  </ListItemIcon>
                  Archive
                </MenuItem>
              </>
            ))}
        </Menu>
        <HandlingUnitListDialog
          open={Boolean(handlingUnitsToShow)}
          onClose={() => setHandlingUnitsToShow(undefined)}
          handlingUnits={handlingUnitsToShow ?? []}
        />
        <CommentsDialog
          commentsThread={activeCommentThread}
          onClose={handleCommentsDialogClose}
          onThreadUpdated={handleCommentThreadUpdate}
        />
        <InventoryCountSyncConfirmationDialog
          open={syncConfirmation.open}
          inventoryCountOrder={syncConfirmation.order}
          processing={syncConfirmation.processing}
          onCancel={() => setSyncConfirmation((prev) => ({ ...prev, open: false }))}
          onConfirm={() => {
            setSyncConfirmation((prev) => ({ ...prev, processing: true }));
            WarehouseWorkService.tryToSyncInventoryCountOrder(syncConfirmation.ids)
              .then(() => {
                refetchData();
                setToast('Inventory count order added to sync queue', 'success');
              })
              .catch((err) => {
                setToast(err.message, 'danger');
              })
              .finally(() => {
                setSyncConfirmation({ open: false, ids: [], processing: false });
              });
          }}
        />
      </CardBody>
    </Card>
  );
}

const InventoryCount = connector(InventoryCountManagement);

export default InventoryCount;
